// import React from 'react';
import styled from 'styled-components'
import {Button, Link, Text} from 'rebass'
import {backgroundColor, color, minWidth, space, width, fontSize} from 'styled-system'


export const PrimaryButton = styled(Button)`
  background-color: #ab80b9;
  border-radius: 23.5px;
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, .16);
  width: 187px;
  height: 47px;
  overflow: hidden;
  color: white;
`;

export const ActiveLeavesFilter = styled(Button)`
    ${width}
    ${minWidth}
    background-color: ${props => props.active === true ? '#2b80b9' : '#fff'};;
    border-radius: 12.975px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .16);
    //width: 49px;
    margin: 3px;
    height: 26px;
    overflow: hidden;
    font-size: 9.5px;
    font-weight: 600 !important;
    color:  ${props => props.active === true ? '#fff' : '#2b80b9'};
  `;

export const LeavesFilter = styled(Button)`
    // background-color: ${props => props.active === true ? '#2b80b9' : '#fff'};
    display: inline-block;
    border-radius: 12.975px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .16);
    min-width: 50px;
    margin: 3px;
    height: 26px;
    overflow: hidden;
    font-size: 9.5px;
    font-weight: 300;
    color: ${props => props.active === true ? '#fff' : '#2b80b9'};
  `;


// Aiport view components


export const LeavesHeading = styled(Text)`
font-size: 17px;
font-weight: 700;
//color: #f95050;
`;

LeavesHeading.defaultProps = {
	color: '#263039'
};

export const LeavesDate = styled(Text)`
display: inline;
width: 50%;
font-size: 13px;
font-weight: 600;
color: #969a9b;
`;

export const DefaultText = styled(Text)`
font-size: 13px;
font-weight: 600;
color: #263039;
`;

export const YellowDot = styled.div`
  position: relative;
  left: -15px;
  top: 15px;
  background-color: #ffc61a;
  border-radius: 50%;
  border: 1px solid #ffc61a;
  width: 7px;
  height: 7px;
  overflow: hidden;
`;


export const GrayDot = styled.div`
  display: inline-block;
  background-color: #707070;
  border-radius: 50%;
  border: 1px solid #707070;
  width: 10px;
  height: 10px;
  margin: 2px;
  overflow: hidden;
`;

export const Status = styled.div`
  display: inline-block;
  position: relative;
  left: 0;
  ${backgroundColor}
  ${space}
  border-radius: 50%;
  //border: 1px solid #707070;
  width: 8px;
  height: 8px;
  margin-top: 4px;
  margin-right: 8px;
  overflow: hidden;
`;

Status.defaultProps = {
	bg: '#707070'
};

export const LeaveStatus = styled.div`
  display: inline-block;
  position: relative;
  left: 0;
  ${backgroundColor}
  ${space}
  ${color}
  text-align: center;
  align-items: center;
  border-radius: 50%;
  font-size: 7px;
  //border: 1px solid #707070;
  width: 14px;
  height: 14px;
  margin-top: 4px;
  margin-right: 5px;
  overflow: hidden;
`;

LeaveStatus.defaultProps = {
	bg: 'white'
};


export const StyledLink = styled(Link)`
 text-decoration: none;
`

StyledLink.defaultProps = {
	color: '#969a9b'
};


export const LeaveActor = styled.div`
	border-radius: 50%;
	//border: 1px solid #707070;
	width: 15px;
	height: 15px;
	margin: 0 2px;
  ${backgroundColor}
`

LeaveActor.defaultProps = {
	bg: 'white'
};

export const LocationContainer = styled.div`
  ${backgroundColor}
  color: white;
  text-align: center;
  width: 85%;
  margin: 10px auto 0 auto;
  padding: 12px 0px;
  font-size: 12px;
  border-radius: 15px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  font-weight: bolder;
`

LocationContainer.defaultProps = {
  bg: '#000000'
}

export const FacultyPositionContainer = styled.div`
  ${backgroundColor}
  color: white;
  text-align: center;
  width: 85%;
  margin: 10px auto 0 auto;
  padding: 12px 0px;
  font-size: 12px;
  border-radius: 15px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  font-weight: bolder;
  min-height: 40px;
  max-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: center;
  align-items: center;
  ${fontSize}
`

FacultyPositionContainer.defaultProps = {
  bg: '#000000'
}

export const MobileFacultyPositionContainer = styled.div`
  ${backgroundColor}
  ${color}
  width: 50%;
  text-align: center;
  margin: 10px auto 0 auto;
  padding: 12px 0px;
  font-size: 12px;
  border-radius: 15px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  font-weight: bolder;
  border: 1px solid #2b80b9;
  ${fontSize}
`

MobileFacultyPositionContainer.defaultProps = {
  bg: '#000000'
}